import PageHeaderElement from "~/common/components/PageHeaderElement";
import { CompanyLogo } from "~/domains/company/components/CompanyLogo";
import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";

export function StaticPageHeader() {
  return (
    <PageHeaderElement className="scha__logo-header">
      <MediasLogo variant="general" href={true} />
      <CompanyLogo className="scha__header__logo" style={{ marginLeft: "auto", marginRight: 0 }} />
    </PageHeaderElement>
  );
}
